import { getValidAttachs } from '../../actions';
import { useChatBodyContext } from '../../../chat-body-context';
import { Values } from '../../composer-env';

const useGetIsFormDisabled = () => {
  const { accessToken, ws } = useChatBodyContext();

  const getIsFormDisabled = (values: Values) => {
    if (!accessToken) return false;
    else if (values.content) return false;
    else if (ws.current && ws.current.readyState != 1) return true;

    const validAttachs = getValidAttachs(values.attachs);
    return validAttachs.length < 1;
  };

  return getIsFormDisabled;
};

export default useGetIsFormDisabled;
